import { defineMessages } from "react-intl";

const messages = defineMessages({
    hour: {
        id: "hour",
    },
    minute: {
        id: "minute",
    },
});

export default messages;
